module.exports = __webpack_public_path__ + "img/test.0b5cf785.svg";